// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingOverlay_loadingContainer__51NsZ","root":"LoadingOverlay_root__qHHyU","loadingTitle":"LoadingOverlay_loadingTitle__8L5Ja"};